import { useState } from 'react';
import axios from 'axios';

export default function EditProfileModal({ profile, user, onClose, onProfileUpdate }) {
    const [formData, setFormData] = useState({
        first_name: profile?.first_name || '',
        last_name: profile?.last_name || '',
        email: profile?.email || '',
        date_of_birth: profile?.date_of_birth || '',
        pesel: profile?.pesel || '',
        phone_number: profile?.phone_number || '',
        address: profile?.address || '',
        job: profile?.job || '',
        username: user?.username || '',
        password: '',
    });

    const [photoFile, setPhotoFile] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhotoFile(file);
            // Create preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Convert empty date string to null
            const dateOfBirth = formData.date_of_birth && formData.date_of_birth.trim() !== '' 
                ? formData.date_of_birth 
                : null;

            // Create FormData for multipart/form-data request
            const formPayload = new FormData();
            formPayload.append('first_name', formData.first_name || '');
            formPayload.append('last_name', formData.last_name || '');
            formPayload.append('email', formData.email || '');
            formPayload.append('date_of_birth', dateOfBirth || '');
            formPayload.append('pesel', formData.pesel || '');
            formPayload.append('phone_number', formData.phone_number || '');
            formPayload.append('address', formData.address || '');
            formPayload.append('job', formData.job || '');
            if (photoFile) formPayload.append('photo', photoFile);

            const updatedProfileRes = await axios.put(
                `${process.env.REACT_APP_API_URL}/profile/student`,
                formPayload,
                {
                    headers: { 
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                        // Don't set Content-Type - axios will set it automatically with boundary for FormData
                    }
                }
            );

            let updatedUserRes = null;

            // Only update password if it's provided and not empty after trimming
            if (formData.password && formData.password.trim().length > 0) {
                updatedUserRes = await axios.put(
                    `${process.env.REACT_APP_API_URL}/profile/user`,
                    {
                        username: formData.username,
                        password: formData.password.trim()
                    },
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                    }
                );
            }

            onProfileUpdate(
                updatedProfileRes.data,
                updatedUserRes ? updatedUserRes.data : user
            );

            // Show success message
            if (formData.password && formData.password.trim().length > 0) {
                alert('Profil i hasło zostały zaktualizowane pomyślnie!');
            } else {
                alert('Profil został zaktualizowany pomyślnie!');
            }

            // Clear password field and photo after successful update
            setFormData(prev => ({ ...prev, password: '' }));
            setPhotoFile(null);
            setPhotoPreview(null);

            onClose();
        } catch (error) {
            console.error("Error updating profile:", error);
            const errorMessage = error.response?.data?.message || error.message || "Wystąpił błąd podczas aktualizacji profilu";
            alert(`Błąd: ${errorMessage}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Edytuj dane</h2>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div>
                        <label className='profile-label'>Imię</label>
                        <input className='profile-input' type="text" name="first_name" value={formData.first_name} onChange={handleChange} placeholder="Imię" />
                    </div>
                    <div>
                        <label className='profile-label'>Nazwisko</label>
                        <input className='profile-input' type="text" name="last_name" value={formData.last_name} onChange={handleChange} placeholder="Nazwisko" />
                    </div>
                    <div>
                        <label className='profile-label'>Email</label>
                        <input className='profile-input' type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" />
                    </div>
                    <div>
                        <label className='profile-label'>Data urodzenia</label>
                        <input className='profile-input' type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
                    </div>
                    <div>
                        <label className='profile-label'>PESEL</label>
                        <input className='profile-input' type="text" name="pesel" value={formData.pesel} onChange={handleChange} placeholder="PESEL" />
                    </div>
                    <div>
                        <label className='profile-label'>Numer telefonu</label>
                        <input className='profile-input' type="tel" name="phone_number" value={formData.phone_number} onChange={handleChange} placeholder="Numer telefonu" />
                    </div>
                    <div>
                        <label className='profile-label'>Adres</label>
                        <input className='profile-input' type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Adres" />
                    </div>
                    <div>
                        <label className='profile-label'>Zawód</label>
                        <input className='profile-input' type="text" name="job" value={formData.job} onChange={handleChange} placeholder="Zawód" />
                    </div>
                    <div>
                        <label className='profile-label'>Zdjęcie profilowe</label>
                        <input 
                            className='profile-input' 
                            type="file" 
                            name="photo" 
                            accept="image/*" 
                            onChange={handlePhotoChange}
                        />
                        {photoPreview && (
                            <div style={{ marginTop: '10px' }}>
                                <img 
                                    src={photoPreview} 
                                    alt="Preview" 
                                    style={{ 
                                        width: '100px', 
                                        height: '100px', 
                                        objectFit: 'cover', 
                                        borderRadius: '50%',
                                        border: '2px solid #e2e8f0'
                                    }} 
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <label className='profile-label'>Nazwa użytkownika</label>
                        <input className='profile-input' type="text" name="username" value={formData.username} onChange={handleChange} placeholder="Username" />
                    </div>
                    <div>
                        <label className='profile-label'>Nowe hasło</label>
                        <input className='profile-input' type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Nowe hasło" />
                    </div>
                    <div className="modal-actions">
                        <button type="submit" disabled={loading} className='btn-profile btn-primary-profile'>
                            {loading ? 'Zapisywanie...' : 'Zapisz'}
                        </button>
                        <button type="button" onClick={onClose} className='btn-profile btn-secondary-profile'>
                            Anuluj
                        </button>
                    </div>
                </form>
                </div>
            </div>
        </div>
    );
}
